.whiteboardFrames {
  width: 168px;
  background-color: rgb(33, 40, 46);
  border-left: 1px solid rgb(60, 69, 77);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  transform: translateX(168px);
  transition: 300ms transform;
  display: flex;
  flex-direction: column;
}
.framesVisible .whiteboardFrames {
  transform: translateX(0);
}
.whiteboardFramesHeader {
  border-bottom: 1px solid rgb(60, 69, 77);
  padding: 8px 18px 8px 24px;
  display: flex;
  justify-content: space-between;
}
.whiteboardFramesHeader .counter {
  color: rgb(156, 164, 171);
  line-height: 30px;
}
.whiteboardFramesHeader .closeFrames {
  color: rgb(181, 181, 181);
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.whiteboardFramesHeader .closeFrames:hover {
  background-color: rgb(20, 23, 26);
  border-color: rgb(60, 69, 77);
}
.whiteboardFramesContainer {
  display: flex;
  flex-direction: column;
  padding: 13px;
  gap: 8px;
  overflow: auto;
}
.whiteboardFrame {
  cursor: pointer;
  color: rgb(156, 164, 171);
  display: block;
  padding: 10px;
  font-size: 11px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid transparent;
  border-radius: 4px;
}
.whiteboardFrame:hover {
  text-decoration: none;
  background-color: rgb(20, 23, 26);
  border-color: rgb(20, 23, 26);
  color: rgb(225, 225, 225);
}
.whiteboardFrameActive,
.whiteboardFrameActive:hover {
  background-color: rgba(var(--rgb-blue-500), 0.3);
  border-color: var(--aha-blue-500);
}
.whiteboardFrame > .imageWrapper > img,
.whiteboardFrame > .imageWrapper > .imagePlaceholder {
  display: block;
  width: 100%;
  border-radius: 4px;
  border: 1px solid rgb(60, 69, 77);
  aspect-ratio: 1.33;
  object-fit: contain;
  background-color: rgb(60, 69, 77);
}
.whiteboardFrame > .whiteboardFrameText {
  margin: 0;
  display: flex;
  justify-content: space-between;
}
.whiteboardFrame .number {
  visibility: hidden;
}
.whiteboardFrame:hover .number {
  visibility: visible;
}

.frameEditorList {
}

.frameEditorItem {
  position: relative;

  a {
    margin: 0 0 8px;
    display: block;
    padding: 16px;
    border-radius: 4px;
    text-decoration: none;
    color: var(--theme-secondary-text);
    display: flex;
    gap: 7px;
    cursor: pointer;
    border: 1px solid var(--theme-primary-border);
    position: relative;
  }

  &.isDragging {
    opacity: 0;
  }

  .imageWrapper {
    width: 100%;
  }
  img,
  .imagePlaceholder {
    display: block;
    object-fit: contain;
    width: 100%;
    height: 79px;
  }

  .frameTitle,
  .frameNumber {
    background-color: var(--theme-primary-background);
    position: absolute;
    font-size: 12px;
    font-weight: normal;
    color: var(--theme-secondary-text);
    visibility: hidden;
  }
  .frameTitle {
    left: -1px;
    right: -1px;
    bottom: -1px;
    padding: 8px;
    margin: 0;
    border: 1px solid var(--theme-primary-border);
    border-radius: 0 0 4px 4px;
  }
  .frameNumber {
    left: 0;
    top: 0;
    margin: 8px;
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid var(--theme-primary-border);
  }

  &:not(.isHidden) a:hover {
    background: var(--theme-tertiary-background);

    .frameTitle,
    .frameNumber {
      visibility: visible;
    }
  }

  a.selected,
  a.selected:hover {
    border-color: var(--theme-project-type-hover-border);

    background: color-mix(
      in srgb,
      var(--theme-primary-background) 30%,
      var(--aha-blue-50)
    );

    .frameTitle,
    .frameNumber {
      border-color: var(--theme-project-type-hover-border);
    }
  }

  /* minor hack to override the hover and .current styles while dragging. Downside is a flash while clicking,
  should be a better way to do this once I can reuse the shared DND code */
  a:active {
    border-color: var(--theme-primary-border);
    background: var(--theme-primary-background);

    .frameTitle,
    .frameNumber {
      visibility: hidden;
    }
  }

  .frameHiddenOverlay {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: 1px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    pointer-events: none;

    .wrapper {
      flex: 1;
    }

    background: color-mix(
      in srgb,
      var(--theme-secondary-background) 88%,
      transparent
    );

    .hiddenIcon,
    .visibleIcon {
      font-size: 17px;
    }
    .visibleIcon {
      display: none;
    }
    aha-button {
      pointer-events: all;
      display: none;
      border-radius: 20px;
      padding: 0px var(--spacer-3);
      background: var(--theme-tertiary-background);
      border: 1px solid var(--theme-primary-border);
      color: var(--theme-secondary-text);
      &:hover {
        background: var(--theme-secondary-background);
      }
    }
  }

  &.isHidden {
    .frameHiddenOverlay {
      display: flex;
    }

    &:hover {
      aha-button {
        display: block;
      }
      .hiddenIcon {
        display: none;
      }
      .visibleIcon {
        display: block;
      }
    }
  }
}

.framesSidePanelTitle {
  display: flex;
  height: 28px;
  align-items: center;
  gap: 7px;
}
.resetFrameOrder {
  background: none;
  padding: 3px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: var(--theme-tertiary-background);
  }
}
.frameCount {
  display: flex;
  gap: 8px;
  color: var(--theme-tertiary-text);
  align-items: end;
  font-size: 11px;
  margin: 0;

  .number {
    color: var(--theme-secondary-text);
  }
}

.presentButtonWrap {
  display: flex;
  padding: var(--spacer-2) 0 var(--spacer-5);

  aha-button {
    width: 100%;
    i {
      font-size: 9px;
      align-self: center;
    }
  }
}
